import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MenuSuspensoComponent } from '../../shared/menu-suspenso/menu-suspenso.component';
import { DecimalPipe, NgForOf, NgIf } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TabelaComponent } from '../../shared/tabela/tabela.component';
import { BasePqrComponent } from '../base-pqr/base-pqr.component';
import { ValidadorTela } from '../../interfaces/validacao.interface';
import { PQRFatorPonderacaoDto } from '../../dtos/pqr-fator-ponderacao.dto';
import { mask_porcentagem_limpa_duas_casas_decimais } from '../../directives/mascaras';
import { MaskitoDirective } from '@maskito/angular';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import {
  CondicaoQualidadeStateService,
  EtapasDeEdicaoService,
  LocalizacaoService,
  MemoriaDeCalculoService,
} from '../../services';
import {
  IconeAtivo,
  LayoutEditorContentService,
} from '../../layouts/layout-editor/layout-editor-content.service';
import { FeatureFlagService } from '../../services/feature-flag/feature-flag.service';
import {
  caminhoImagemLateralCondicaoQualidade,
  corFundoLateralCondicaoQualidade,
  opcoesMenuLateralAtivas,
  opcoesMenuLateralInativas,
  tituloMenuLateralCondicaoQualidade,
} from '../../layouts/layout-editor/template/lateral-navegacao-condicao-qualidade';
import { DialogPqrFatorPonderacaoComponent } from '../../shared/dialog-pqr-fator-ponderacao/dialog-pqr-fator-ponderacao.component';
import { PtBrNumberDirective } from '../../directives/pt-br-number.directive';
import { ResultadoMatriculasFatorPonderacao } from "../../dtos/resultado-matriculas-fator-ponderacao";

interface PQRFatorPonderacaoTable {
  descricaoItem: string;
  fatorPonderacao: number;
}

@Component({
  selector: 'app-fator-ponderacao',
  standalone: true,
  imports: [
    MatIcon,
    MatTooltip,
    MenuSuspensoComponent,
    NgForOf,
    NgIf,
    DecimalPipe,
    ReactiveFormsModule,
    TabelaComponent,
    MaskitoDirective,
    FormsModule,
    PtBrNumberDirective,
  ],
  templateUrl: './fator-ponderacao.component.html',
  styleUrl: './fator-ponderacao.component.scss',
})
export class FatorPonderacaoComponent
  extends BasePqrComponent<PQRFatorPonderacaoDto>
  implements OnInit, ValidadorTela
{
  protected valoresEdicao: PQRFatorPonderacaoDto[] = [];
  protected valoresPadrao: PQRFatorPonderacaoDto[] = [];
  mask_porcentagem_limpa_duas_casas =
    mask_porcentagem_limpa_duas_casas_decimais;

  dadosTabela: PQRFatorPonderacaoTable[] = [];
  totalMatriculas: number[] = []

  private readonly FATORES_CONFIG = [
    {
      descricaoItem: 'Educação Escolar Indígena',
      campo: 'pqrFatorPondIndigena',
    },
    {
      descricaoItem: 'Educação Escolar Quilombola',
      campo: 'pqrFatorPondQuilombola',
    },
    {
      descricaoItem:
        'Educação Profissional Integrada e concomitante ao Ensino Médio¹',
      campo: 'pqrFatorPondEnsMedioProfissional',
    },
    {
      descricaoItem:
        'Educação Profissional Integrada e concomitante à EJA²',
      campo: 'pqrFatorPondEjaProfissional',
    },
    {
      descricaoItem: 'Atendimento Educacional Especializado (AEE)³',
      campo: 'pqrFatorPondAee',
    },
  ] as const;

  constructor(
    router: Router,
    toastr: ToastrService,
    dialogRestaurarValores: MatDialog,
    private dialogPqrFatorPonderacao: MatDialog,
    private layoutEditorContentService: LayoutEditorContentService,
    private condicaoQualidadeStateService: CondicaoQualidadeStateService,
    private memoriaCalculoService: MemoriaDeCalculoService,
    public featureFlagService: FeatureFlagService,
  ) {
    super(router, toastr, dialogRestaurarValores, dialogPqrFatorPonderacao);
    this.layoutEditorContentService.definirIconeAtivo(IconeAtivo.QUALIDADE);
    this.layoutEditorContentService.definirTituloMenuLateral(
      tituloMenuLateralCondicaoQualidade,
    );
    this.layoutEditorContentService.definirOpcoesAtivas(
      opcoesMenuLateralAtivas,
    );
    this.layoutEditorContentService.definirOpcoesInativas(
      opcoesMenuLateralInativas,
    );
    this.layoutEditorContentService.definirCaminhoImagem(
      caminhoImagemLateralCondicaoQualidade,
    );
    this.layoutEditorContentService.definirCorFundoMenuLateral(
      corFundoLateralCondicaoQualidade,
    );
    this.layoutEditorContentService.definiOpcaoAtivaSelecionada(9);
    this.layoutEditorContentService.definirExibirBotaoAnterior(true);
    this.layoutEditorContentService.definirRotaAnterior(
      '/relatorio2/condicao-qualidade/alimentacao-escolar',
    );
    this.layoutEditorContentService.definirExibirBotaoProximo(true);
    this.layoutEditorContentService.definirRotaProximo(
      '/relatorio2/condicao-qualidade/direitos-obrigacoes-trabalhistas',
    );
  }

  async ngOnInit() {
    this.carregarDadosInterno();
    if (this.featureFlagService.funcionalidadeHabilitada('995-fator-ponderacao-calculo.exibicao-fator-ponderacao')) {
      const memoriaCalculo = await this.memoriaCalculoService.buscarMemoriaDeCalculoLocalizacao();
      this.totalMatriculas = this.montarMatriculasPonderacao(memoriaCalculo.resultadoMatriculasFatorPonderacao!)
    }
  }

  montarMatriculasPonderacao(
    memoriaCalculo: ResultadoMatriculasFatorPonderacao,
  ): number[] {
    return [
      memoriaCalculo.totalMatriculaIndigena,
      memoriaCalculo.totalMatriculaQuilombola,
      memoriaCalculo.totalMatriculaEnsMedioProf,
      memoriaCalculo.totalMatriculaEjaProf,
      memoriaCalculo.totalMatriculaAee,
    ];
  }

  private carregarDadosInterno() {
    this.carregarDados(
      () => this.condicaoQualidadeStateService.getPQRFatorPonderacaoPadrao(),
      () => this.condicaoQualidadeStateService.getPQRFatorPonderacaoValores(),
    );
    this.dadosTabela = this.toTabela(this.valoresEdicao);
  }

  protected openDialogPqrValoresPadrao(): void {
    const dialogRef = this.dialogPqrFatorPonderacao.open(
      DialogPqrFatorPonderacaoComponent,
      {
        panelClass: 'dialog-pqr-fator-ponderacao',
      },
    );

    dialogRef.componentInstance.dados =
      this.condicaoQualidadeStateService.getPQRFatorPonderacaoPadrao();
  }

  public criaMensagemInconsistencia(): string[] {
    return [];
  }

  private toTabela(dto: PQRFatorPonderacaoDto[]): PQRFatorPonderacaoTable[] {
    return this.FATORES_CONFIG.map(({ descricaoItem, campo }) => ({
      descricaoItem,
      fatorPonderacao: dto[0][campo],
    }));
  }

  atualizarDadosTabela(): void {
    const dto: Partial<PQRFatorPonderacaoDto> = {
      codigoFatorPonderacao: this.valoresEdicao[0].codigoFatorPonderacao,
    };

    this.FATORES_CONFIG.forEach(({ campo }, i) => {
      dto[campo] = Number(
        String(this.dadosTabela[i].fatorPonderacao).split(',').join('.'),
      );
    });

    this.valoresEdicao = [dto as PQRFatorPonderacaoDto];
    this.atualizarValores();
  }

  protected atualizarValores() {
    this.dadosTabela = this.toTabela(this.valoresEdicao);
    this.condicaoQualidadeStateService.setPQRFatorPonderacaoValores(
      this.valoresEdicao,
    );
  }

  garantirMinimoTabela(index: number): void {
    const valorBruto = this.dadosTabela[index].fatorPonderacao;

    if (!valorBruto || valorBruto < 1) {
      this.dadosTabela[index].fatorPonderacao = 1;
      this.atualizarDadosTabela();
    }
  }
}

export function canDeactivateFnFatorPonderacao(
  component: FatorPonderacaoComponent,
): Observable<boolean> | boolean {
  if (component.criaMensagemInconsistencia().length > 0) {
    return false;
  }
  return true;
}
